import { createContext, useCallback, useContext, useState } from "react";

/**
 * Robo-Ball facial-expression state. Consumers set `smile` during the
 * FiguTour (or while the assistant is streaming, if wired later) and
 * revert to `idle` — the blink animation is paused while smile is active.
 */
const RoboBallExpressionContext = createContext({
  state: "idle",
  setState: () => {},
});

export function RoboBallExpressionProvider({ children }) {
  const [state, setStateInternal] = useState("idle");
  // Stable setter so consumers can pass it as a prop / effect dep safely.
  const setState = useCallback((next) => {
    setStateInternal(next === "smile" ? "smile" : "idle");
  }, []);
  return (
    <RoboBallExpressionContext.Provider value={{ state, setState }}>
      {children}
    </RoboBallExpressionContext.Provider>
  );
}

export function useRoboBallExpression() {
  return useContext(RoboBallExpressionContext);
}
